import React, { useEffect, useState } from 'react';

import {
  FORM_VALUE_ENUM,
  FORM_VALUE_INTER,
  FORM_VALUE_TYPE,
  SOURCE_ENUM
} from './constant';

import { useMutation } from 'react-query';

import { FormikValues, useFormik } from 'formik';
import { validation } from '../../lib/validation';
import {
  boolean,
  fullNameReg,
  notEnglishLetter,
  notRussiaLatter,
  onlyTextAndNumber,
  phoneOperator,
  phoneUA,
  required,
  validateCodes
} from '../../lib/validation/service';
import { sendAuthSignupData } from './action';
import { Component } from './component';

import { SELECT_OPTION_ITEM_DATA } from '../../common/select';
import { HttpRequest } from '../../lib/http';

export const Container: React.FC = () => {
  const [isMultiCode, setIsMultiCode] = React.useState(false);
  const params = new URLSearchParams(window.location.search);

  const initialValues = {
    [FORM_VALUE_ENUM.FIRST_NAME]: '',
    [FORM_VALUE_ENUM.PHONE]: '',
    [FORM_VALUE_ENUM.CODES]: ['', '', '', ''],//isMultiCode ? ['', '', '', ''] : null,
    [FORM_VALUE_ENUM.CODE]: '', //isMultiCode ? null : '',
    [FORM_VALUE_ENUM.SHOP]: null,
    [FORM_VALUE_ENUM.PROMO_ID]: parseInt(params.get('promoId')!) || 1,
    [FORM_VALUE_ENUM.REGISTRATION_SOURCE]: SOURCE_ENUM.DESKTOP,
    [FORM_VALUE_ENUM.CITY]: 0,
    [FORM_VALUE_ENUM.NOVAPOST]: '',
    [FORM_VALUE_ENUM.AGREE]: false,
  };

  const config = {
    [FORM_VALUE_ENUM.FIRST_NAME]: [required, notRussiaLatter, notEnglishLetter, fullNameReg],
    [FORM_VALUE_ENUM.PHONE]: [required, phoneUA, phoneOperator],
    [FORM_VALUE_ENUM.SHOP]: [required, notRussiaLatter],
    [FORM_VALUE_ENUM.CODES]: isMultiCode ? [validateCodes] : [],
    [FORM_VALUE_ENUM.CODE]: !isMultiCode ? [required, notRussiaLatter, onlyTextAndNumber] : [],//, minLength(11)
    [FORM_VALUE_ENUM.REGISTRATION_SOURCE]: [required, notRussiaLatter],
    [FORM_VALUE_ENUM.CITY]: isMultiCode ? [required, notRussiaLatter] : [],
    [FORM_VALUE_ENUM.NOVAPOST]: isMultiCode ? [required] : [],
    [FORM_VALUE_ENUM.AGREE]: [boolean],
  };

  const validate = (values: FormikValues) => validation(values, config);

  const action = useMutation(sendAuthSignupData, {});

  const formik: FormikValues = useFormik({
    initialValues,
    validate,
    validateOnMount: true,
    onSubmit: (values: FORM_VALUE_INTER) => {
      const { code, codes, ...rest } = values;
      return action.mutate({
        ...rest,
        code: !isMultiCode ? code : null,
        codes: isMultiCode ? codes : null
      });
    },
  });

  const isFieldError = (name: FORM_VALUE_TYPE): boolean => {
    return formik.errors[name] && formik.touched[name] ? true : false;
  };

  const getFieldError = (name: FORM_VALUE_TYPE): string | undefined =>
    isFieldError(name) ? formik.errors[name] : undefined;

  const isSubmitDisabled = () => {
    if (!formik.isValid) {
      return true;
    }
    if (!formik.dirty) {
      return true;
    }
    if (action.isLoading) {
      return true;
    }
    // if (action.isSuccess) {
    //   return true;
    // }
  };

  const isLoading = () => {
    if (action.isLoading) {
      return true;
    }
  };

  const isError = () => {
    if (action.isError && !action.isLoading && getErrorMessage()) {
      return true;
    }
  };

  const getErrorMessage = () => {
    const error: any = action.error as any;
    if (error) {
      return error?.message.slice(6);
    }
    //@ts-ignore
    if (action?.data?.response?.statusCode == 400 && !error) {
      //@ts-ignore
      return action?.data?.response?.message;
    }
  };

  const isSuccess = () => {
    if (action.isSuccess && !action.isLoading) {
      return true;
    }
  };

  const getFieldValue = (name: FORM_VALUE_TYPE) => formik.values[name];

  const setFieldValue = async (
    name: FORM_VALUE_TYPE,
    e: SELECT_OPTION_ITEM_DATA,
  ) => {
    await formik.setFieldValue(name, e.value);
    await formik.setFieldValue(`${name}_label`, e.label);
  };

  const setValue = (options: SELECT_OPTION_ITEM_DATA[], value: any) => {
    const optionList = options?.filter(
      (item: SELECT_OPTION_ITEM_DATA) => item.value == formik.values[value],
    )[0];
    return optionList ? optionList : null;
  };

  const isDisabled = (name: FORM_VALUE_TYPE) => {
    return formik.values[name] === '' ? true : undefined;
  };


  const [prizeDataQuery, setPrizeDataQuery] = useState(null);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // const raw = params.get('prizeData');
    const phone = params.get('phone');
    const spinId = params.get('spinId');

    if (!phone || !spinId) return; //!raw || 

    const fetchPrize = async () => {
      try {
        const data = await HttpRequest.get('/prize', {
          params: { phone, spinId },
        });

        // const parsed = JSON.parse(decodeURIComponent(escape(atob(raw))));
        setPrizeDataQuery(data.data ?? data as any);
      } catch {
        console.warn('Invalid prizeData in query');
      }
    };

    fetchPrize();
  }, []);

  const prizeData = (action.data as any)?.prizes?.[0] ?? prizeDataQuery;

  return (
    <Component
      prizeData={prizeData}
      prizeDataForced={!!prizeDataQuery && !(action.data as any)?.prizes?.[0]}
      isFieldError={isFieldError}
      getFieldError={getFieldError}
      isSubmitDisabled={isSubmitDisabled}
      getFieldValue={getFieldValue}
      setFieldValue={setFieldValue}
      formik={formik}
      isLoading={isLoading()}
      isError={isError()}
      errorMessage={getErrorMessage()}
      isDisabled={isDisabled}
      setValue={setValue}
      isSuccess={isSuccess()}
      isMultiCode={isMultiCode}
      setIsMultiCode={setIsMultiCode}
    />
  );
};
